import React, { Component } from 'react';
// import { StripeProvider, Elements, injectStripe, } from 'react-stripe-elements';
import { Layout } from '../../Common/Component';
import AccountOverview from './Services/AccountOverview';
import AccountInfo from './Services/AccountInfo';
import MyServices from './Services/MyServices';
import Dogs from './Services/Dogs';
import BillingInfo from './Services/BillingInfo';
import Invoice from './Services/Invoice';
import Messages from './Services/Messages';
import Proposals from './Services/Proposals';

// const StripedBillingInfo = injectStripe(BillingInfo);

class UserAccount extends Component {
  state = {
    current:0,
    message_count: 0
  }

  componentDidMount = () => {
    let is_edit = JSON.parse(localStorage.getItem('is_edit'));
    if (is_edit && is_edit.is_edit) {
      this.setState({
        current: 2
      })
      localStorage.removeItem('is_edit');
    }
    else {
      this.setState({
        current: 0
      })
      localStorage.removeItem('is_edit');
      localStorage.removeItem('is_property_type');
    }
    sessionStorage.clear();
    if (JSON.parse(localStorage.getItem('userKey'))) {
      this.props.getMessagesCount();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300);
    }
    else {
      this.props.history.push('/login');
    }

    // code added for commercial - Esha Singh
    let property_type = JSON.parse(localStorage.getItem('is_property_type')) || null;
    if (property_type && property_type?.property_type === 'community') {
      this.setState({
        current: 1
      })
    }
    /////////////////////////////////////////
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (Object.keys(props.messageCount.data).length > 0 && props.messageCount.data !== this.props.messageCount.data) {
      this.setState({
        message_count: props.messageCount.data.count
      })
    }
    if (Object.keys(props.messageCount.errors).length > 0 && props.messageCount.errors !== this.props.messageCount.errors) {
      // display error messsage

    }
  }

  // Render Service Component
  renderStep = () => {
    const { current } = this.state;
    switch (current) {
    case 0:
      return (<AccountOverview
        // Common Function
        tabChange={(e) => { this.tabChange(e) }}
        // API Function
        getAccountInfo={this.props.getAccountInfo}
        getMessagesList={this.props.getMessagesList}
        getPastUpcomingService={this.props.getPastUpcomingService}
        getServiceOrder={this.props.getServiceOrder}
        addServiceBag={this.props.addServiceBag}
        getPayment={this.props.getPayment}
        getServiceStats={this.props.getServiceStats}
        getGeocodeAddress={this.props.getGeocodeAddress}
        resetGeocodeAddress={this.props.resetGeocodeAddress}
        getInvoiceCreditMemoList={this.props.getInvoiceCreditMemoList}

        // Reducer
        AccountInfo={this.props.AccountInfo}
        getMessages={this.props.getMessages}
        UPASTService={this.props.UPASTService}
        serviceOrder={this.props.serviceOrder}
        addBag={this.props.addBag}
        GetPayment={this.props.GetPayment}
        ServiceStats={this.props.ServiceStats}
        GoogleApi={this.props.GoogleApi}
        // eslint-disable jsx-props-no-spreading
        {...this.props}
      />)
    case 1:
      return (
        <AccountInfo
          // API Function
          getNotification={this.props.getNotification}
          getAccountInfo={this.props.getAccountInfo}
          updateUser={this.props.updateUser}
          updateNotification={this.props.updateNotification}
          getCommericalAccountInfo={this.props.getCommericalAccountInfo}
          updateCommericalAccountInfo={this.props.updateCommericalAccountInfo}
          getCommunityInfo={this.props.getCommunityInfo}
          updateCommunityInfo={this.props.updateCommunityInfo}
          // Reducer
          AccountInfo={this.props.AccountInfo}
          NotificationList={this.props.NotificationList}
          updatedUser={this.props.updatedUser}
          updatedNotification={this.props.updatedNotification}
          GetCommercialInfo={this.props.GetCommercialInfo}
          UpdateCommercialUser={this.props.UpdateCommercialUser}
          CommunityInfo={this.props.CommunityInfo}
          UpdateCommunity={this.props.UpdateCommunity}
        />
      )
    case 2:
      return (
        <MyServices
          // API Function
          getServiceOrder={this.props.getServiceOrder}
          ViewService={this.props.ViewService}
          pauseService={this.props.pauseService}
          getPauseService={this.props.getPauseService}
          deletePauseService={this.props.deletePauseService}
          addReviewInService={this.props.addReviewInService}
          // Reducer
          serviceOrder={this.props.serviceOrder}
          viewMyService={this.props.viewMyService}
          servicePause={this.props.servicePause}
          pauseServiceList={this.props.pauseServiceList}
          pauseServiceDeleted={this.props.pauseServiceDeleted}
          addReview={this.props.addReview}
          // eslint-disable jsx-props-no-spreading
          {...this.props}
          tabChange={(e) => { this.tabChange(e) }}
        />)
    case 3:
      return (<Dogs
        // API Function
        addPets={this.props.addPets}
        getPets={this.props.getPets}
        UpdatePets={this.props.UpdatePets}
        deletePets={this.props.deletePets}
        getServiceOrder={this.props.getServiceOrder}
        // Reducer
        DogList={this.props.DogList}
        addedDog={this.props.addedDog}
        updatedDog={this.props.updatedDog}
        deletedPets={this.props.deletedPets}
        serviceOrder={this.props.serviceOrder}
      />)
    case 4:
      return (
        <BillingInfo
          // Reducers
          AccountInfo={this.props.AccountInfo}
          getCard={this.props.getCard}
          serviceOrder={this.props.serviceOrder}
          newCard={this.props.newCard}
          cardDeleted={this.props.cardDeleted}
          updatedCard={this.props.updatedCard}
          enquiry={this.props.enquiry}
          BillingInfo={this.props.BillingInfo}

          // API Call
          getCardList={this.props.getCardList}
          getServiceOrder={this.props.getServiceOrder}
          addNewCard={this.props.addNewCard}
          deleteCard={this.props.deleteCard}
          UpdateCard={this.props.UpdateCard}
          getBillingInfo={this.props.getBillingInfo}
        />
      )
    case 5:
      return (<Invoice
        // API
        getAccountListing={this.props.getAccountListing}
        printInvoice={this.props.printInvoice}
        getInvoiceCreditMemoList={this.props.getInvoiceCreditMemoList}
        // Reducer
        GetInvoice={this.props.GetInvoice}
        DownloadInvoice={this.props.DownloadInvoice}
      />)
    case 6:
      return (<Messages
        // Reducers
        getMessages={this.props.getMessages}
        createdMessage={this.props.createdMessage}
        messageReply={this.props.messageReply}
        ticketClosed={this.props.ticketClosed}
        getReasons={this.props.getReasons}
        zipcodeReducers={this.props.zipcodeReducers}
        // API Function
        getMessagesList={this.props.getMessagesList}
        createMessage={this.props.createMessage}
        messageReplay={this.props.messageReplay}
        closeTicket={this.props.closeTicket}
        getMessagesCount={this.props.getMessagesCount}
        getCSVData={this.props.getCSVData}
        getReasonList={this.props.getReasonList}
        checkZipCode={this.props.checkZipCode}

      />)

    case 7: return (
      <Proposals
        // API
        getProposalsListing={this.props.getProposalsListing}
        getProposalPdf={this.props.getProposalPdf}
        
        // Reducers
        GetProposal={this.props.GetProposal}
      />
    )
    default:
      return (<AccountOverview />
      )
    }
  }
  // Render Tab change
  tabChange = (e) => {
    this.setState({
      current: e
    })
    this.props.getMessagesCount()
  }

  render() {
    let { current, message_count } = this.state;
    let userKey = JSON.parse(localStorage.getItem('userKey')) || null;
    let role = [];
    
    if (userKey) {
      role = userKey?.user?.role
    }

    return (
      <Layout>
        <div className="my_account_wrapper">
          <div className="user_action">
            <div className="container">
              <ul className="user_action_list">
                <li className={current === 0 ? 'active' : ''} onClick={() => { this.tabChange(0) }}>
                  <span>ACCOUNT OVERVIEW</span>
                </li>
                <li className={current === 1 ? 'active' : ''} onClick={() => { this.tabChange(1) }}>
                  <span>ACCOUNT Information</span>
                </li>
                <li className={current === 2 ? 'active' : ''} onClick={() => { this.tabChange(2) }}>
                  <span>MY SERVICES</span>
                </li>
                {
                  role.includes('commercial_customer') ?
                    <li className={current === 7 ? 'active' : ''} onClick={() => { this.tabChange(7) }}>
                      <span>Proposals</span>
                    </li>
                    : ''
                }
                {
                  role.includes('commercial_customer') ? '' :
                    <li className={current === 3 ? 'active' : ''} onClick={() => { this.tabChange(3) }}>
                      <span>DOGS</span>
                    </li>
                }
                <li className={current === 4 ? 'active' : ''} onClick={() => { this.tabChange(4) }}>
                  <span>Billing Information</span>
                </li>
                <li className={current === 5 ? 'active' : ''} onClick={() => { this.tabChange(5) }}>
                  <span>INVOICES</span>
                </li>
                <li className={current === 6 ? 'active' : ''} onClick={() => { this.tabChange(6) }}>
                  <span>Messages<div className="count">{message_count}</div> </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="service_details">

            {this.renderStep()}
          </div>
        </div>
      </Layout>
    );
  }
}

export default UserAccount;